// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3iBMD44jKK-WIbLVM6ctro{text-underline-offset:.3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"underlineOffset": "_3iBMD44jKK-WIbLVM6ctro"
};
module.exports = ___CSS_LOADER_EXPORT___;
